export default function Footer() {
  return (
    <footer className="bg-[#f5f5f0] border-t-4 border-[#1a1a1a]">
      <div className="max-w-screen-xl mx-auto px-4 py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {/* Brand */}
        <div className="lg:col-span-1">
          <div className="text-2xl font-black text-[#1a1a1a] mb-3">🦸 CLEVYS</div>
          <p className="text-gray-500 text-sm leading-relaxed">
            Votre super-héros serrurier &amp; vitrier à Paris depuis 1982. En alerte 6j/7, 24h/24 sur toute l'Île-de-France. Avec Clevys, aucune serrure ne résiste !
          </p>
        </div>

        {/* Pouvoirs */}
        <div>
          <h4 className="font-black text-[#1a1a1a] text-sm tracking-widest mb-4">POUVOIRS</h4>
          <ul className="flex flex-col gap-2">
            {['Reproduction de clés', 'Dépannage urgence', 'Réparation cambriolage', 'Remplacement serrure', 'Installation vitre'].map((item) => (
              <li key={item}>
                <a href="https://clevys.fr/#services" className="text-gray-500 text-sm hover:text-[#1a1a1a] transition-colors">{item}</a>
              </li>
            ))}
          </ul>
        </div>

        {/* Navigation */}
        <div>
          <h4 className="font-black text-[#1a1a1a] text-sm tracking-widest mb-4">NAVIGATION</h4>
          <ul className="flex flex-col gap-2">
            {[
              { label: 'Accueil', href: 'https://clevys.fr/' },
              { label: 'À propos', href: 'https://clevys.fr/#apropos' },
              { label: 'FAQ', href: 'https://clevys.fr/#faq' },
              { label: 'Avis fans', href: 'https://clevys.fr/#avis' },
              { label: 'Contact', href: 'https://clevys.fr/#contact' },
            ].map((item) => (
              <li key={item.label}>
                <a href={item.href} className="text-gray-500 text-sm hover:text-[#1a1a1a] transition-colors">{item.label}</a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="font-black text-[#1a1a1a] text-sm tracking-widest mb-4">CONTACT</h4>
          <ul className="flex flex-col gap-2">
            <li>
              <a href="tel:0660441172" className="text-gray-500 text-sm hover:text-[#1a1a1a] transition-colors">📞 06 60 44 11 72</a>
            </li>
            <li>
              <a href="mailto:contact@clevys.fr" className="text-gray-500 text-sm hover:text-[#1a1a1a] transition-colors">📧 contact@clevys.fr</a>
            </li>
            <li className="text-gray-500 text-sm">📍 86 Av. Philippe Auguste, 75011 Paris</li>
            <li className="text-gray-500 text-sm">📍 57 Bd Jean Jaurès, 92100 Boulogne</li>
          </ul>
        </div>
      </div>

      <div className="border-t-2 border-[#1a1a1a]/10">
        <div className="max-w-screen-xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <span className="text-gray-400 text-xs">© Clevys 2024 — Tous droits réservés — Protégeant Paris depuis 1982</span>
          <span className="text-gray-400 text-xs">86 Av. Philippe Auguste, 75011 Paris</span>
        </div>
      </div>
    </footer>
  );
}
